// Diferencia en días de CALENDARIO entre `fechaStr` (YYYY-MM-DD) y hoy —
// ambas fechas se normalizan a medianoche local antes de restar, así el
// resultado no depende de la hora del día en que se ejecuta el cálculo.
// Comparar contra un ancla fija como T12:00:00 (como se hacía antes) hacía
// que una fecha de HOY se viera como "vencida" en cuanto pasaban las 12:00,
// aunque técnicamente ese mismo día siguiera vigente.
function diasCalendario(fechaStr) {
  const objetivo = new Date(fechaStr + 'T00:00:00');
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return Math.round((objetivo - hoy) / 86400000);
}

// Único listado de "contrato vigente en sentido amplio" — cualquier estado
// operativo normal de un contrato en marcha, ni de baja ni en fase de
// captación (ver ESTADOS_CAPTACION en MantenimientosView.js/mantenimientosKpis.js).
// Antes había copias sueltas de esta misma lista en mantenimientosKpis.js,
// MantenimientosView.js (TabAnalitica y TabSocios) e InformesView.js, cada
// una ligeramente distinta (una olvidaba 'vencido', otra usaba solo 2 de los
// 10 estados) — por eso "Contratos vigentes" y el ARR de al lado podían no
// referirse al mismo conjunto de contratos. Exportada desde aquí porque es
// el mismo archivo que ya decide, en calcularEstado(), a qué estado
// pertenece cada contrato.
export const ESTADOS_VIGENTE_AMPLIO = [
  'activo', 'vence_pronto', 'vencido', 'sepa_generado', 'pendiente_factura',
  'pendiente_agendar', 'mantenimiento_agendado', 'pendiente_renovar',
  'pendiente_reagendar', 'sepa_devuelto',
];

/**
 * Calcula el estado visual de un contrato de mantenimiento a partir de su
 * estado almacenado en Firestore y las fechas relevantes.
 *
 * NUNCA devuelve 'firmado_activo' — lo convierte a 'activo', 'vence_pronto'
 * o 'vencido' según la fecha de referencia correspondiente.
 */
export function calcularEstado(m) {
  const stored = m.estado;

  if (stored === 'pendiente_firma') return 'contrato_enviado';

  if (['baja', 'contrato_enviado', 'contactado', 'interesado', 'sin_respuesta',
       'no_interesado', 'sepa_generado', 'pendiente_factura', 'pendiente_agendar',
       'pendiente_renovar', 'sepa_devuelto'].includes(stored)) return stored;

  if (stored === 'mantenimiento_agendado') {
    const ref = m.fechaProximoMantenimiento;
    if (!ref) return 'mantenimiento_agendado';
    // Distinto de 'pendiente_renovar': aquí el contrato sigue vigente, solo
    // falta reagendar una visita que no se hizo — no tiene nada que ver con
    // renovar el contrato (eso es 'pendiente_renovar', que se guarda de
    // verdad al pulsar "Renovar" sobre un contrato vencido). Antes ambas
    // situaciones compartían la misma etiqueta y confundían a quien lo veía.
    return diasCalendario(ref) < 0 ? 'pendiente_reagendar' : 'mantenimiento_agendado';
  }

  if (stored === 'firmado_activo' || m.tieneContrato) {
    // "Vence pronto"/"Vencido" son sobre la RENOVACIÓN del contrato — solo
    // fechaVencimientoContrato puede decidirlos. fechaProximoMantenimiento es
    // una pregunta distinta (cuándo toca la próxima visita) y NUNCA debe
    // sustituir a la fecha de vencimiento: mezclar las dos hacía que un
    // contrato pareciera "a punto de vencer" solo porque tocaba visita,
    // cuando en realidad no había ninguna fecha de vencimiento guardada.
    // Si falta fechaVencimientoContrato, el contrato se ve como "activo" sin
    // alarmas falsas — el hueco de dato se señala aparte (KPI "Sin fecha de
    // vencimiento" en MantenimientosView.js).
    const ref = m.fechaVencimientoContrato;
    if (!ref) return 'activo';
    const dias = diasCalendario(ref);
    if (dias < 0)   return 'vencido';
    if (dias <= 45) return 'vence_pronto';
    return 'activo';
  }

  return 'sin_contrato';
}
